import React from 'react';
import { Icon, IconButton, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const ActViewDetail = ({ userInfo }) => {
  const navigate = useNavigate();

  const handleUserClick = () => {
    navigate(`/user/${userInfo.id}`);
  };
  return (
    <Tooltip title="Chi tiết người dùng" placement="top">
      <IconButton className="button" aria-label="Chi tiết" onClick={handleUserClick}>
        <Icon>remove_red_eye</Icon>
      </IconButton>
    </Tooltip>
  );
};

export default ActViewDetail;
